// Copyright (c) 2017 Deere & Company

import UserSelectedClaimsAccordion from './user-selected-claims-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    auditPreparation: state.tcsm.prepareAudit.auditPreparation
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => {

    const {
        removeFromAudit
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            removeFromAudit
        }
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(UserSelectedClaimsAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/user-selected-claims-accordion/index.js